<script lang="ts">
  import { Loader } from "lucide-svelte"
  import type { Snippet } from "svelte"
  interface Props {
    loading: boolean
    children: Snippet
    class?: string
  }

  let { loading, children, class: css }: Props = $props()
</script>

<div
  class={["relative", css ? css : "inline-block"]}
  style={loading ? "opacity: 0.5" : ""}
>
  {#if loading}
    <Loader class="rotate absolute" style="top:0.2rem;left:40%" />
  {/if}

  {@render children()}
</div>
